export default __webpack_public_path__ + "hero-demo.png?c51e1a183438693bd51f4030d023d33c";